import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"
import RebuttingMyOpponentsAttacksHeader from "../components/rebutting-my-opponents-attacks-header"
import RebuttingMyOpponentsAttacksDoc from "../components/rebutting-my-opponents-attacks-doc"

const RebuttingMyOpponentsAttacksPage = () => (
  <Layout>
    <Seo title="Rebutting My Opponent's Attacks" />
    <RebuttingMyOpponentsAttacksHeader />
    <RebuttingMyOpponentsAttacksDoc />
  </Layout>
)

export default RebuttingMyOpponentsAttacksPage
